function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "security-tier-3_svg__linear-gradient",
  x1: 397.43,
  y1: 614.86,
  x2: 250.34,
  y2: 12.83,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#371447"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#491c5d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#592472"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#5f2779"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "security-tier-3_svg__linear-gradient-2",
  x1: 300,
  y1: 524.5,
  x2: 300,
  y2: -72.22,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5f2779"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#592472"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#491c5d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#371447"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "security-tier-3_svg__linear-gradient-4",
  x1: 56.01,
  y1: 178.18,
  x2: 520.14,
  y2: 368.34,
  gradientTransform: "rotate(-35.7 325.177 288.456)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#371447"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#3a174a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#73498a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#9c6db9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#b584d5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#bf8ce0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "security-tier-3_svg__linear-gradient-5",
  x1: 205.57,
  y1: 381.01,
  x2: 394.43,
  y2: 381.01,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#9eefe1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.97,
  stopColor: "#33c1a6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "security-tier-3_svg__linear-gradient-6",
  x1: 156.58,
  y1: 282.19,
  x2: 443.42,
  y2: 282.19,
  xlinkHref: "#security-tier-3_svg__linear-gradient-5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "security-tier-3_svg__linear-gradient-7",
  x1: 344.58,
  y1: 355.18,
  x2: 345.74,
  y2: 438.46,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#cb3974"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#ffb7d1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "security-tier-3_svg__linear-gradient-8",
  x1: 367.98,
  y1: 433.27,
  x2: 388.98,
  y2: 433.27,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.07,
  stopColor: "#ffb7d1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cb3974"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "security-tier-3_svg__linear-gradient-9",
  x1: 371.09,
  y1: 417.94,
  x2: 385.87,
  y2: 417.94,
  xlinkHref: "#security-tier-3_svg__linear-gradient-8"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "security-tier-3_svg__clip-path"
}, /*#__PURE__*/React.createElement("path", {
  className: "security-tier-3_svg__cls-1",
  d: "M136.66 76.07h326.68A36.63 36.63 0 01500 112.7v211.83c0 110.44-134.27 200-200 200-69.51 0-200-89.53-200-200V112.7a36.63 36.63 0 0136.66-36.63z"
})), /*#__PURE__*/React.createElement("style", null, ".security-tier-3_svg__cls-1,.security-tier-3_svg__cls-10,.security-tier-3_svg__cls-8{fill:none;stroke-miterlimit:10}.security-tier-3_svg__cls-1{stroke:#5f2779;stroke-width:10px}.security-tier-3_svg__cls-3{fill:url(#security-tier-3_svg__linear-gradient-2)}.security-tier-3_svg__cls-6{fill:#cca1e5}.security-tier-3_svg__cls-7{fill:#bf8ce0}.security-tier-3_svg__cls-17,.security-tier-3_svg__cls-7{opacity:.3}.security-tier-3_svg__cls-10,.security-tier-3_svg__cls-8{stroke:#cca1e5;stroke-linecap:round;stroke-width:2.45px}.security-tier-3_svg__cls-12{fill:#33c1a6}.security-tier-3_svg__cls-17{fill:#e3fffa}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M117.88 50h364.24A40.83 40.83 0 01523 90.84V327c0 123.14-149.7 223-223 223-77.51 0-223-99.82-223-223V90.84A40.83 40.83 0 01117.88 50z",
  fill: "url(#security-tier-3_svg__linear-gradient)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "security-tier-3_svg__cls-3",
  d: "M136.66 76.07h326.68A36.63 36.63 0 01500 112.7v211.83c0 110.44-134.27 200-200 200-69.51 0-200-89.53-200-200V112.7a36.63 36.63 0 0136.66-36.63z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "security-tier-3_svg__cls-3",
  d: "M136.66 76.07h326.68A36.63 36.63 0 01500 112.7v211.83c0 110.44-134.27 200-200 200-69.51 0-200-89.53-200-200V112.7a36.63 36.63 0 0136.66-36.63z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#security-tier-3_svg__clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  transform: "rotate(35.7 325.157 288.493)",
  opacity: 0.4,
  fill: "url(#security-tier-3_svg__linear-gradient-4)",
  d: "M243.71-28h162.83v632.87H243.71z"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "security-tier-3_svg__cls-1",
  d: "M136.66 76.07h326.68A36.63 36.63 0 01500 112.7v211.83c0 110.44-134.27 200-200 200-69.51 0-200-89.53-200-200V112.7a36.63 36.63 0 0136.66-36.63z"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  className: "security-tier-3_svg__cls-6",
  x: 119.98,
  y: 105.48,
  width: 107.15,
  height: 24.2,
  rx: 12.1
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  className: "security-tier-3_svg__cls-6",
  x: 246.28,
  y: 105.48,
  width: 107.15,
  height: 24.2,
  rx: 12.1
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  className: "security-tier-3_svg__cls-6",
  x: 372.59,
  y: 105.48,
  width: 107.15,
  height: 24.2,
  rx: 12.1
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  className: "security-tier-3_svg__cls-7",
  cx: 227.06,
  cy: 173.22,
  r: 6.01
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  className: "security-tier-3_svg__cls-7",
  cx: 308.65,
  cy: 194.13,
  r: 3.01
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  className: "security-tier-3_svg__cls-7",
  cx: 124.04,
  cy: 220.87,
  r: 3.01
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  className: "security-tier-3_svg__cls-7",
  cx: 469.51,
  cy: 356.24,
  r: 3.01
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  className: "security-tier-3_svg__cls-7",
  cx: 435.85,
  cy: 321.55,
  r: 6.01
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "security-tier-3_svg__cls-8",
  d: "M131.02 321.55v13.97M138.01 328.53h-13.97"
});

var _ref16 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  className: "security-tier-3_svg__cls-10",
  d: "M441.87 184.13v13.98M448.85 191.12h-13.97"
}));

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M205.57 317.55v60.58a5.47 5.47 0 002.38 4.51l24.76 16.94 64.21 43.93a5.46 5.46 0 006.16 0l64.21-43.93 24.76-16.94a5.47 5.47 0 002.38-4.51v-60.58z",
  fill: "url(#security-tier-3_svg__linear-gradient-5)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "security-tier-3_svg__cls-12",
  d: "M300 382.16l-94.43-64.61v15.78l91.35 62.5a5.42 5.42 0 006.16 0l91.35-62.5v-15.78z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M297.4 182.9L158.55 279a4.57 4.57 0 000 7.53l54.7 37.42 7.78 5.33 76.37 52.25a4.55 4.55 0 005.16 0L379 329.25l7.78-5.33 54.7-37.42a4.57 4.57 0 000-7.53L302.6 182.9a4.54 4.54 0 00-5.2 0z",
  fill: "url(#security-tier-3_svg__linear-gradient-6)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M384.24 428.66V326.92a2.75 2.75 0 00-1.17-2.25l-69.75-48.51a6.26 6.26 0 00-8 .71 6.27 6.27 0 00.87 9.59l66.24 45.62a2.76 2.76 0 011.18 2.26v103.71z",
  fill: "url(#security-tier-3_svg__linear-gradient-7)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M373.23 421.17l-5.1 21.73a5.39 5.39 0 005.24 6.63h10.22a5.39 5.39 0 005.25-6.63l-5.11-21.73a5.39 5.39 0 00-10.5 0z",
  fill: "url(#security-tier-3_svg__linear-gradient-8)"
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 378.48,
  cy: 417.94,
  r: 7.39,
  fill: "url(#security-tier-3_svg__linear-gradient-9)"
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  className: "security-tier-3_svg__cls-12",
  cx: 304.23,
  cy: 275.78,
  r: 11.9
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  className: "security-tier-3_svg__cls-17",
  x: 178.09,
  y: 255.46,
  width: 80.35,
  height: 5.45,
  rx: 2.73,
  transform: "rotate(-34.98 218.237 258.166)"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  className: "security-tier-3_svg__cls-17",
  x: 254.53,
  y: 223.49,
  width: 18.88,
  height: 5.45,
  rx: 2.73,
  transform: "rotate(-34.98 263.944 226.205)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M136.66 76.07h326.68A36.63 36.63 0 01500 112.7v211.83c0 110.44-134.27 200-200 200h0c-69.51 0-200-89.53-200-200V112.7a36.63 36.63 0 0136.66-36.63z",
  stroke: "#371447",
  opacity: 0.7,
  strokeWidth: 10,
  fill: "none",
  strokeMiterlimit: 10
});

function SvgSecurityTier3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "security-tier-3_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
}

export default SvgSecurityTier3;